<template>
  <div class="profile d-flex" @click="$emit('click')">
    <profile-image v-if="profileImage" size="md" :user="{profileImage, initials: profileImage.initials}"
                   :suppress-initials="profileImage.suppressInitials" class="me-2" />
    <div class="d-inline-block text-start">
      <div class="small-text">
        {{ label }}
      </div>

      <!-- Q: Why have a button here when the whole component is clickable?
           A: For accessibility to screenreader and keyboard navigation users -->
      <button v-if="campaignerContactable" type="button" :title="i18n.t('public.contact.contact_creator')"
              class="btn btn-link unmarked-link p-0" @click="$emit('click')">
        {{ creatorDisplayName }}
        <i class="icon-mail" />
      </button>
      <div v-else>
        {{ creatorDisplayName }}
      </div>
    </div>
  </div>
</template>

<script>
import ProfileImage from '@/components/members/profile-image'

export default {
  components: { ProfileImage },

  props: {
    campaignerContactable: {
      type: Boolean,
      required: true
    },
    creatorDisplayName: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    profileImage: {
      type: Object,
      required: false
    }
  },

  emits: ['click']
}
</script>
